import { useEffect, useState } from 'react';

export const useMessages = (): Record<string, string> | undefined => {
  const [message, setMessages] = useState<Record<string, string>>();

  useEffect(() => {
    (async () => {
      const response = await fetch('/messages/default.json');
      try {
        const data = await response.json();
        setMessages(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    })();
  }, []);

  return message;
};
